import React from 'react';
import './LegalPage.css';

// Lisa's final documents (10.29.2026_Privacy_Policy.docx and 10.29.2026_Terms_of_Use.docx), converted word for word:
// headings, bold / italic text, bullet lists and links are kept exactly as in the Word files.
// To update later: replace the text inside DOCS below, and update TERMS_VERSION / PRIVACY_VERSION in Page1.js
// so the acceptance record names the version the voter agreed to.
const DOCS = {
 "privacy": {
  "title": "Privacy Policy",
  "subtitle": "Independent Times News LLC · Voting Made Easy · Effective October 2026",
  "effective": "Effective as of October 2026",
  "blocks": [
   {
    "type": "p",
    "runs": [
     {
      "t": "This Privacy Policy (\"Policy\") applies to Voting Made Easy and to Independent Times News LLC (\"Company\") and governs data collection and usage. For the purposes of this Policy, unless otherwise noted, all references to the Company include vote.indtimes.news, www.independenttimes.news, and www.indtimes.news. Voting Made Easy is the free tool from Independent Times News that helps voters cut through the noise and make clearer choices — no party bias, just straightforward help so you can vote with confidence. Before using Voting Made Easy, you will be asked to check a box confirming that you agree to this Policy and our Terms of Use. By checking that box and by using the Company's websites and applications, you consent to the data practices described in this statement.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "I. Collection of Your Personal Information"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We collect the personal information you provide to us directly, along with limited technical information that is collected automatically when you visit our websites (described below). The personal information you provide, and why we collect it, is:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Mailing address.",
      "b": true,
      "i": false
     },
     {
      "t": " Your address is required to use Voting Made Easy: it is how we look up your ballot and show you the correct races and candidates for where you live. We store your address together with your email address as part of our record of who has used Voting Made Easy. We may also use this information to produce anonymous, aggregate statistics about how and where Voting Made Easy is used (for example, the number of users in a county); these statistics do not identify you. We do not record which candidates you view, and we never collect or record how you vote.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Email address (required).",
      "b": true,
      "i": false
     },
     {
      "t": " Your email address is required to use Voting Made Easy. When you provide it, you will receive our Independent Voter Dispatches, produced by the Independent Times newsroom at indtimes.news, and other emails from us. Requiring an email address also helps us protect Voting Made Easy against automated and abusive use.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Unsubscribing.",
      "b": true,
      "i": false
     },
     {
      "t": " Every email we send, starting with your welcome email, includes an unsubscribe link, and you can unsubscribe at any time. Unsubscribing stops all emails from us. It does not delete your email address or mailing address from our records; to have them deleted, see \"How long we keep your information and how to delete it\" below.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Information you send us.",
      "b": true,
      "i": false
     },
     {
      "t": " If you contact us by email or through the Contact Us page on any of our websites, we receive your name, email address, and whatever you include in your message. We store that information securely and use it to respond to you and to keep a record of our correspondence.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "How long we keep your information and how to delete it.",
      "b": true,
      "i": false
     },
     {
      "t": " We keep your email address and mailing address until you ask us to delete them. You may request deletion at any time by emailing legal@independenttimes.news with the subject line \"Delete My Information\" from the email address you used with Voting Made Easy. Within thirty (30) days after we receive your request, we will delete your email address and mailing address from our records, direct our service providers to do the same, as described in Section IV, and confirm by email when the deletion is complete. We keep a record of your request and the date we completed it, and we keep your email address on a do-not-email list so that you are not added back to our mailing list by mistake. Anonymous, aggregate statistics that do not identify you are not affected by deletion. Once your information is deleted, you will no longer receive any emails from us, and you will need to enter your address and email again to use Voting Made Easy.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We do not currently run sweepstakes or contests, and we do not collect payment information. If we offer products or services in the future that collect additional personal information, we will update this Policy before doing so.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Information collected automatically. Like most websites, our hosting provider automatically collects certain technical information when you visit, such as your IP address, browser type, device type, operating system, referring pages, and pages viewed. We use this information to operate and secure our websites. We use cookies and similar technologies only for essential site functions. We do not currently use any analytics, advertising, or tracking tools on our websites. You can control or delete cookies through your browser settings. If we add analytics or similar tools in the future, we will update this Policy before doing so.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We do not collect biometric data.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "II. Sharing Information with Third Parties"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Company does not sell, rent, lease, or trade your personal information to anyone, and we do not share your personal information with any third party for its own marketing or other independent use. We have no data-sharing partnerships of any kind. If that ever changes, we will update this Policy before doing so.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The only third parties that handle your data are the service providers that make our websites and tools work — our cloud hosting and email delivery providers. These providers are prohibited from using your personal information for any purpose other than providing their services to the Company, and they are required to maintain the confidentiality of your information.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Company may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on the Company or the site; (b) protect and defend the rights or property of the Company; and/or (c) act under exigent circumstances to protect the personal safety of users of the Company, or the public.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "If the Company is involved in a merger, acquisition, or sale of all or a portion of its assets, you will be notified via a prominent notice on our websites of any change in ownership or in the uses of your personal information, as well as any choices you may have regarding that information.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "III. Your Privacy Rights; We Do Not Sell Your Personal Information"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We do not sell your personal information, and we do not share it for cross-context behavioral advertising. Because we do not sell or share personal information in this way, no opt-out is required. If our practices ever change, we will update this Policy and provide a clear means to opt out before any such sale or sharing occurs.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Depending on where you live, you may have rights under the California Consumer Privacy Act (CCPA/CPRA) or other state privacy laws, including the right to: (a) know what personal information we have collected about you; (b) request a copy of that information; (c) request correction of inaccurate information; (d) request deletion of your information; and (e) not be discriminated against for exercising these rights.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "To exercise any of these rights, contact us at legal@independenttimes.news with the subject line \"Privacy Request.\" We will verify your request and respond within the time required by applicable law.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "IV. Right to Deletion"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Delete your personal information from our records; and",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Direct any service providers to delete your personal information from their records.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Please note that we may not be able to comply with requests to delete your personal information if it is necessary to:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, and provide a good or service requested by you, or reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between you and us;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that activity;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Debug to identify and repair errors that impair existing intended functionality;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Comply with the California Electronic Communications Privacy Act;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when our deletion of the information is likely to render impossible or seriously impair the achievement of such research, provided we have obtained your informed consent;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Comply with an existing legal obligation; or",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Otherwise, use your personal information internally in a lawful manner that is compatible with the context in which you provided the information.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "V. Children Under 13"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Company does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of 13, you must ask your parent or guardian for permission to use this platform. If a parent or guardian becomes aware that his or her child has provided us with personal information without their consent, they should contact us at legal@independenttimes.news, and we will delete that information from our files within a reasonable time. If you are under 18, you may use our services only with the permission of a parent or guardian.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "VI. External Data Storage and Third-Party Links"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We may store your data on servers provided by third-party hosting vendors with whom we have contracted, including cloud infrastructure providers located in the United States. All processing of your information takes place in the United States; if you access our services from outside the United States, your information will be transferred to, processed, and stored in the United States under United States privacy standards.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Our services contain links to third-party websites, including candidate campaign websites, social media platforms, and government election offices. This Policy does not apply to those sites, and we are not responsible for their privacy practices. We encourage you to review the privacy policy of any site you visit.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "VII. Data Security and Retention"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We use commercially reasonable administrative, technical, and physical safeguards designed to protect your personal information. No method of transmission or storage is completely secure, and we cannot guarantee absolute security. We keep your email address and mailing address until you request deletion, as described in Section I. We retain other personal information only as long as needed for the purposes described in this Policy, to comply with legal obligations, or to resolve disputes.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "VIII. Changes to This Statement"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Company reserves the right to change this Policy from time to time. For example, when there are changes in our services, changes in our data protection practices, or changes in the law. When changes to this Policy are significant, we will inform you. You may receive a notice by email to the email address you provided to us, by a prominent notice on our application, and/or by an update to this page and its effective date. Your continued use of the application and/or services available after such modifications will constitute your: (a) acknowledgment of the modification of this Policy; and (b) agreement to abide and be bound by this modified Policy.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "IX. Contact Information"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Company welcomes your questions or comments regarding this Statement of Privacy. If you believe that the Company has not adhered to this Statement, please contact the Company at:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Independent Times News LLC",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "570 Lake Cook Road, Suite 300",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Deerfield, Illinois 60015",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Email: ",
      "b": false,
      "i": false
     },
     {
      "t": "legal@independenttimes.news",
      "b": true,
      "i": false,
      "href": "mailto:legal@independenttimes.news"
     }
    ]
   }
  ]
 },
 "terms": {
  "title": "Terms of Use",
  "subtitle": "Independent Times News LLC · Voting Made Easy · Effective October 2026",
  "effective": "Effective as of October 2026",
  "blocks": [
   {
    "type": "p",
    "runs": [
     {
      "t": "Voting Made Easy is a free, nonpartisan tool from Independent Times News that helps you research candidates: their positions on the issues independent voters care about most, plus links to their campaign websites, social media, and their Ballotpedia and OpenSecrets pages. We gather this information from our verified database and public sources, including Google Search. Candidate summaries are generated using artificial intelligence (AI) tools, and our team, including a fact-checker, reviews them as carefully as we can, but AI can make mistakes, positions change, and errors are possible. Always verify election rules, dates, deadlines, and ballot information with your state's official election website (linked at the top of the Voting Made Easy screen), and verify a candidate's positions with the candidate's own campaign, before acting on anything you read here. We do not endorse candidates or parties. Before using Voting Made Easy, you must check a box agreeing to the full Terms below and our Privacy Policy.",
      "b": false,
      "i": true
     }
    ]
   },
   {
    "type": "h",
    "text": "1. Agreement Between User and vote.indtimes.news"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Welcome to vote.indtimes.news (the \"Site\"), operated by Independent Times News LLC (\"Independent Times,\" \"we,\" \"us\"). The Site and the Voting Made Easy tool and related services (together, the \"Services\") are offered to you conditioned on your acceptance, without modification, of the terms, conditions, and notices contained herein (the \"Terms\"). Before you can use Voting Made Easy, you must affirmatively agree to these Terms and our Privacy Policy by checking the box provided on the screen where you enter your address and email. By checking that box, and by using the Services, you agree to all such Terms. Please read them carefully and keep a copy for your reference.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "2. About the Services"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Voting Made Easy is the free tool from Independent Times News that helps voters cut through the noise and make clearer choices. No party bias, just straightforward help so you can vote with confidence. The Services include candidate profiles showing positions on key policy issues, links to campaign websites and social media, and related voter resources.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "3. Informational Purposes Only; Nonpartisan; No Endorsement"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Services provide information about candidates, elections, and public policy for general informational and educational purposes only. Independent Times is a nonpartisan resource: nothing on the Services constitutes an endorsement of, or opposition to, any candidate, political party, ballot measure, or policy position. Nothing on the Services constitutes legal, tax, or professional advice, or official voting guidance. We are not affiliated with, or endorsed by, any government agency, election authority, political party, campaign, or candidate. Candidate names, photographs, and campaign materials referenced on the Services belong to their respective owners and appear for identification and informational purposes only.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "4. Accuracy of Information; Your Duty to Verify"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We compile candidate information — including stated positions on policy issues, biographical details, and campaign website and social media links — from our verified database and from publicly available sources, including Google Search, campaign websites, public statements, voting records, questionnaires, and news reporting. Candidate summaries are generated using artificial intelligence (AI) tools from these sources. Our team, including a fact-checker, reviews this information, and we invite candidates to review their own profiles and tell us about any errors. Each candidate profile also links to the candidate's Ballotpedia and OpenSecrets pages, and the Voting Made Easy screen links to your state's official election website, so that you can check the information independently. We make good-faith efforts to review and fact-check this information. However, you understand and agree that:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Candidate positions can change at any time, and public sources may be incomplete, outdated, ambiguous, or inaccurate;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Summarizing a candidate's position necessarily involves editorial judgment, and our characterization may differ from how the candidate or others would characterize it;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "AI-generated summaries may misstate, oversimplify, or omit parts of a candidate's position, even after review;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "Election rules, dates, deadlines, polling locations, registration requirements, and ballot contents vary by state and change frequently;",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "li",
    "ordered": false,
    "runs": [
     {
      "t": "The Services may contain errors, omissions, or outdated information despite our efforts.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Before relying on any information from the Services, you must verify: (a) all election dates, deadlines, registration requirements, and ballot information with your state's Secretary of State, state election board, or county or local election office; and (b) any candidate's current positions with the candidate's own campaign. Official state election websites can be located through the U.S. Election Assistance Commission and the National Association of Secretaries of State.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "5. Corrections"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We want the Services to be accurate. If you believe any information on the Services is incorrect, please let us know. Candidates and campaign representatives may submit a correction request by emailing corrections@indtimes.news with the subject line \"Correction Request.\" Please identify the candidate, describe the information you believe is inaccurate, and include a source supporting the correction, such as the campaign's website or a public statement. We research and evaluate every correction request in good faith and correct information where our review shows a correction is needed. We may not respond individually to each request.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "6. Privacy"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Your use of the Services is subject to our Privacy Policy, which governs the Site and describes our data collection practices. Please review it.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "7. Electronic Communications"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Visiting the Site or sending emails to Independent Times constitutes electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications that we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communications be in writing. By providing your email address to use Voting Made Easy, you agree to receive our Independent Voter Dispatches and other emails from us, as described in our Privacy Policy. Every email includes an unsubscribe link, and you may unsubscribe at any time.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "8. Children"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Independent Times does not knowingly collect, online or offline, personal information from persons under the age of thirteen. If you are under 18, you may use the Services only with the permission of a parent or guardian.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "9. Links to Third-Party Sites and Services"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Services contain links to other websites (\"Linked Sites\"), including candidate campaign websites, social media platforms, government election offices, and news sources. Linked Sites are not under the control of Independent Times, and Independent Times is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site or any changes or updates to a Linked Site. These links are provided only as a convenience, and the inclusion of any link does not imply endorsement by Independent Times of the site or any association with its operators.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Certain features of the Services rely on service providers that work on our behalf, such as our cloud hosting and email delivery providers. These providers handle your information only to operate the Services for us and may not use it for any other purpose, as described in our Privacy Policy. We do not sell your information, we do not share it with any third party for that party's own marketing or other independent use, and we have no data-sharing partnerships.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "10. License; No Unlawful or Prohibited Use; Intellectual Property"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "You are granted a non-exclusive, non-transferable, revocable license to access and use the Services strictly in accordance with these Terms. As a condition of your use, you warrant that you will not use the Services for any purpose that is unlawful or prohibited by these Terms. You may not use the Services in any manner that could damage, disable, overburden, or impair them or interfere with any other party's use and enjoyment of them, and you may not obtain or attempt to obtain any materials or information through any means not intentionally made available through the Services. You may not use automated systems, bots, or scraping tools to extract data from the Services for commercial purposes without our prior written agreement, and you may not misrepresent content from the Services as official government information or as a candidate's own statement.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "All content included as part of the Services — such as text, graphics, logos, images, the compilation thereof, and any software used on the Site — is the property of Independent Times or its suppliers and is protected by copyright and other intellectual-property laws. You agree to observe all copyright and proprietary notices and restrictions in such content. You will not modify, publish, transmit, reverse engineer, sell, create derivative works from, or otherwise exploit any of the content, in whole or in part. Content is not for resale and is for your personal, non-commercial use.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "11. International Users"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "The Services are controlled, operated, and administered by Independent Times from our offices within the United States. If you access the Services from a location outside the United States, you are responsible for compliance with all local laws. You agree that you will not use the Services in any country or in any manner prohibited by any applicable laws, restrictions, or regulations.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "12. Indemnification"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "You agree to indemnify, defend, and hold harmless Independent Times, its officers, directors, employees, agents, and third parties from any losses, costs, liabilities, and expenses (including reasonable attorneys' fees) relating to or arising out of your use of or inability to use the Services, any postings made by you, your violation of these Terms, your violation of any rights of a third party, or your violation of any applicable laws, rules, or regulations. Independent Times reserves the right, at its own cost, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with Independent Times in asserting any available defenses.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "13. Arbitration"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "In the event the parties are not able to resolve any dispute between them arising out of or concerning these Terms, or any provisions hereof, whether in contract, tort, or otherwise at law or in equity for damages or any other relief, then such dispute shall be resolved only by final and binding arbitration pursuant to the Federal Arbitration Act, conducted by a single neutral arbitrator and administered by the American Arbitration Association, or a similar arbitration service selected by the parties, in a location mutually agreed upon by the parties. The arbitrator's award shall be final, and judgment may be entered upon it in any court having jurisdiction. In the event that any legal or equitable action, proceeding, or arbitration arises out of or concerns these Terms, the prevailing party shall be entitled to recover its costs and reasonable attorneys' fees. The parties agree to arbitrate all disputes and claims in regard to these Terms or any disputes arising as a result of these Terms, whether directly or indirectly, including tort claims that are a result of these Terms. The parties agree that the Federal Arbitration Act governs the interpretation and enforcement of this provision. The entire dispute, including the scope and enforceability of this arbitration provision, shall be determined by the arbitrator. This arbitration provision shall survive the termination of these Terms.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Small claims court.",
      "b": true,
      "i": false
     },
     {
      "t": " Notwithstanding the foregoing, either you or Independent Times may bring an individual claim in the small claims court of Lake County, Illinois, instead of arbitration, as long as the claim qualifies for small claims court and remains there on an individual (non-class, non-representative) basis.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "30-day right to opt out of arbitration.",
      "b": true,
      "i": false
     },
     {
      "t": " You may opt out of this arbitration agreement by emailing legal@independenttimes.news within thirty (30) days after the date you first accept these Terms, with the subject line \"Arbitration Opt-Out.\" Your email must come from, or state, the email address you used with Voting Made Easy and must clearly say that you are opting out of arbitration. If you opt out, disputes between you and Independent Times will be resolved in court as provided in Section 16, and the rest of these Terms will continue to apply to you. Opting out of arbitration will not affect any other arbitration agreement you may have with us.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "14. Class Action Waiver"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Any arbitration under these Terms will take place on an individual basis; class arbitrations and class, representative, or collective actions are not permitted. THE PARTIES AGREE THAT A PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN EACH'S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PUTATIVE CLASS, COLLECTIVE, AND/OR REPRESENTATIVE PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY GENERAL ACTION AGAINST THE OTHER. Further, unless both you and Independent Times agree otherwise, the arbitrator may not consolidate more than one person's claims and may not otherwise preside over any form of a representative or class proceeding.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "15. Liability Disclaimer"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. INDEPENDENT TIMES NEWS LLC AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "INDEPENDENT TIMES NEWS LLC AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES, AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES, AND RELATED GRAPHICS ARE PROVIDED \"AS IS\" WITHOUT WARRANTY OR CONDITION OF ANY KIND. INDEPENDENT TIMES NEWS LLC AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, PRODUCTS, SERVICES, AND RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL INDEPENDENT TIMES NEWS LLC AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA, OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF THE SITE, WITH THE DELAY OR INABILITY TO USE THE SITE OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES, AND RELATED GRAPHICS OBTAINED THROUGH THE SITE, OR OTHERWISE ARISING OUT OF THE USE OF THE SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE, EVEN IF INDEPENDENT TIMES NEWS LLC OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. THIS INCLUDES, WITHOUT LIMITATION, ANY DECISION MADE OR ACTION TAKEN IN RELIANCE ON INFORMATION FROM THE SITE, AND ANY MISSED ELECTION DEADLINES, REGISTRATION ERRORS, OR VOTING OUTCOMES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SITE.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "16. Termination; Governing Law"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Independent Times reserves the right, in its sole discretion, to terminate your access to the Services or any portion thereof at any time, without notice. To the maximum extent permitted by law, this agreement is governed by the laws of the State of Illinois and, subject to the Arbitration provision above, you consent to the exclusive jurisdiction and venue of the state and federal courts located in Lake County, Illinois, in all disputes arising out of or relating to the use of the Services. Use of the Services is unauthorized in any jurisdiction that does not give effect to all provisions of these Terms, including, without limitation, this section.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "You agree that no joint venture, partnership, employment, or agency relationship exists between you and Independent Times as a result of this agreement or use of the Services. Independent Times's performance of this agreement is subject to existing laws and legal process, and nothing contained in this agreement is in derogation of Independent Times's right to comply with governmental, court, and law-enforcement requests or requirements relating to your use of the Services or information provided to or gathered by Independent Times with respect to such use. If any part of this agreement is determined to be invalid or unenforceable pursuant to applicable law — including, but not limited to, the warranty disclaimers and liability limitations set forth above — then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision, and the remainder of the agreement shall continue in effect.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Unless otherwise specified herein, this agreement constitutes the entire agreement between the user and Independent Times with respect to the Services and supersedes all prior or contemporaneous communications and proposals, whether electronic, oral, or written. A printed version of this agreement and of any notice given in electronic form shall be admissible in judicial or administrative proceedings to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form. It is the express wish of the parties that this agreement and all related documents be written in English.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "17. Changes to Terms"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Independent Times reserves the right, in its sole discretion, to change the Terms under which the Services are offered. The most current version of the Terms will supersede all previous versions. We encourage you to periodically review the Terms to stay informed of our updates.",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "h",
    "text": "18. Contact Us"
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "We welcome your questions or comments regarding these Terms:",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Independent Times News LLC",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "570 Lake Cook Road, Suite 300",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Deerfield, Illinois 60015",
      "b": false,
      "i": false
     }
    ]
   },
   {
    "type": "p",
    "runs": [
     {
      "t": "Email: ",
      "b": false,
      "i": false
     },
     {
      "t": "legal@independenttimes.news",
      "b": true,
      "i": false,
      "href": "mailto:legal@independenttimes.news"
     }
    ]
   }
  ]
 }
};

function Runs({ runs }) {
  return runs.map((r, i) => {
    let el = r.t;
    if (r.href) el = <a href={r.href} {...(r.href.startsWith('mailto:') ? {} : { target: '_blank', rel: 'noopener noreferrer' })}>{el}</a>;
    if (r.i) el = <em>{el}</em>;
    if (r.b) el = <strong>{el}</strong>;
    return <React.Fragment key={i}>{el}</React.Fragment>;
  });
}
const plain = b => (b.runs || []).map(r => r.t).join('').trim();

// Turn the flat list of blocks into: intro paragraphs + sections (heading, paragraphs, lists, contact address)
function buildSections(blocks) {
  const intro = [], sections = [];
  let cur = null;
  for (const b of blocks) {
    if (b.type === 'h') { cur = { heading: b.text, items: [] }; sections.push(cur); continue; }
    const target = cur ? cur.items : intro;
    const last = target[target.length - 1];
    if (b.type === 'li') {
      if (last && last.type === 'list' && last.ordered === b.ordered) last.items.push(b.runs);
      else target.push({ type: 'list', ordered: b.ordered, items: [b.runs] });
    } else if (cur && /contact/i.test(cur.heading) && plain(b).length < 60 && !plain(b).endsWith(':')) {
      if (last && last.type === 'address') last.lines.push(b.runs);
      else target.push({ type: 'address', lines: [b.runs] });
    } else target.push({ type: 'p', runs: b.runs });
  }
  return { intro, sections };
}

function Item({ item }) {
  if (item.type === 'list') {
    const List = item.ordered ? 'ol' : 'ul';
    return <List className="legal-list">{item.items.map((runs, i) => <li key={i}><Runs runs={runs} /></li>)}</List>;
  }
  if (item.type === 'address') return <address className="legal-contact">{item.lines.map((runs, i) => <div key={i}><Runs runs={runs} /></div>)}</address>;
  return <p><Runs runs={item.runs} /></p>;
}

function LegalPage({ type, onBack }) {
  const doc = type === 'privacy' ? DOCS.privacy : DOCS.terms;
  const { intro, sections } = buildSections(doc.blocks);
  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-inner">
          <button className="legal-back-btn" onClick={onBack}>← Back</button>
          <h1 className="legal-title">{doc.title}</h1>
          <p className="legal-subtitle">{doc.subtitle}</p>
        </div>
      </div>

      <div className="legal-body">
        <div className="legal-content">
          {intro.map((item, i) => (
            item.type === 'p'
              ? <p key={i} className={`legal-intro${item.runs.every(r => r.i || !r.t.trim()) ? ' legal-intro--italic' : ''}`}><Runs runs={item.runs} /></p>
              : <Item key={i} item={item} />
          ))}
          {sections.map((s, i) => (
            <section key={i} className="legal-section">
              <h2 className="legal-section-heading">{s.heading}</h2>
              {s.items.map((item, j) => <Item key={j} item={item} />)}
            </section>
          ))}
          {doc.effective && <p className="legal-effective">{doc.effective}</p>}
        </div>
      </div>
    </div>
  );
}

export default LegalPage;